import { call, put, takeLatest, select } from 'redux-saga/effects'
import { IPublishedSearchPacksAction, types } from '../types/publishedSearch'
import * as actions from '../actions/publishedSearch'
import * as selectors from '../selectors/publishedSearch'
import * as services from '../services/publishedSearch'
import { trace } from '../services/common'
import {
  stringifyNestedQuery,
  decoratePublishedSearchQuery,
} from '../services/search'

export function* publishedSearchPacksSaga(action: IPublishedSearchPacksAction) {
  try {
    const actionQuery = yield call(stringifyNestedQuery, action.query)
    const query = yield call(decoratePublishedSearchQuery, actionQuery)
    const skip = yield select(selectors.selectSkipQuery)
    // TODO: Reset all serach if skip is less that
    // default value of items per page PPP-5006
    if (skip < 20) {
      yield put(actions.resetPublishedSearch())
    }
    const { items, totalCount } = yield call(services.searchPublishedGraphics, {
      ...query,
      skip,
    })
    yield put(actions.searchPublishedPacksSuccess(items, totalCount))
  } catch (err) {
    trace(err)
    yield put(actions.searchPublishedPacksFailure(err.message))
  }
}

export function* publishedSearchWatcher() {
  yield takeLatest(
    types.PUBLISHED_SEARCH_PACKS__STARTED,
    publishedSearchPacksSaga
  )
}
